import { render, staticRenderFns } from "./DeathHorse.vue?vue&type=template&id=148eadd3&"
import script from "./DeathHorse.vue?vue&type=script&lang=js&"
export * from "./DeathHorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports